var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 0.75H0V14.25H6.75V2.25C6.75 1.42125 6.07875 0.75 5.25 0.75Z",
    fill: "#3290EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5852 8.32875L14.8935 6.98325L14.2275 4.3185C14.1442 3.984 13.8443 3.75 13.5 3.75H12.2812H8.25C8.25 3.75 8.25 13.0883 8.25 13.5C8.25 13.9117 8.28825 14.25 8.28825 14.25C8.47725 15.933 9.8925 17.25 11.625 17.25C13.3575 17.25 14.7728 15.933 14.9618 14.25H17.25C17.664 14.25 18 13.914 18 13.5V9C18 8.71575 17.8395 8.45625 17.5852 8.32875ZM11.625 15.75C10.5915 15.75 9.75 14.9093 9.75 13.875C9.75 12.8407 10.5915 12 11.625 12C12.6585 12 13.5 12.8407 13.5 13.875C13.5 14.9093 12.6585 15.75 11.625 15.75ZM9.75 7.5V5.25H13.008L13.5 7.5H9.75Z",
    fill: "#3290EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.38800708f440f65ab9eed7900d4736c2.svg";
export { ForwardRef as ReactComponent };